import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useThirdPartyBrandSafetyTargetingValues = () => {
    const { value, onChange } = useFormFieldValue({
        field: 'thirdPartyBrandSafetyTargeting.values',
    });
    return { value, onChange };
};
